module.exports = __webpack_public_path__ + "static/input-of-rpc-parameters-4a7c15f79fc4d4ea06aa50716e5bc4dd.png";